import { DEFAULT_STATE } from '../constants'

export const initialTagsState = {
  tags: DEFAULT_STATE.tags,
}
